import { z } from 'zod';
import { isoUtcDateTimeSchema, positiveIntIdSchema } from '../shared/schemas.js';

export const actionTagIdSchema = positiveIntIdSchema;

export const actionTagLabelSchema = z
  .string()
  .trim()
  .min(1, 'Le libellé est obligatoire.')
  .max(40, 'Le libellé ne peut pas dépasser 40 caractères.');

export const actionTagSchema = z.object({
  id: z.number().int().positive(),
  label: z.string(),
  /** Actions du catalogue qui portent ce tag, archivées comprises. */
  actionCount: z.number().int().nonnegative(),
  createdAt: isoUtcDateTimeSchema,
  updatedAt: isoUtcDateTimeSchema,
});

export type ActionTag = z.infer<typeof actionTagSchema>;

export const saveActionTagSchema = z
  .object({
    label: actionTagLabelSchema,
  })
  .strict();

export type SaveActionTagInput = z.infer<typeof saveActionTagSchema>;

export const actionTagListSchema = z.object({
  tags: z.array(actionTagSchema),
});

export type ActionTagList = z.infer<typeof actionTagListSchema>;
